import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createInspectionService } from '../../api/inspection-service.ts';
import { CreateInspectionServiceRequest } from '../../api/requests/inspection-service-request.ts';

export default function useCreateInspectionService(): UseMutationResult<
  Awaited<ReturnType<typeof createInspectionService>>,
  Error,
  CreateInspectionServiceRequest
> {
  return useMutation({
    mutationFn: createInspectionService,
  });
}
